import { Dialog as KDialog } from '@kobalte/core/dialog'
import { Search } from 'lucide-solid'
import type { JSX } from 'solid-js'
import { createEffect, createSignal, For } from 'solid-js'

export type Command = { id: string; label: string; hint?: string; action: () => void; keywords?: string[] }

export const CommandPalette = (props: { commands: Command[] }): JSX.Element => {
  const [open, setOpen] = createSignal(false)
  const [q, setQ] = createSignal('')

  createEffect(() => {
    const h = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        setOpen(true)
      }
    }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  })

  const filtered = () => {
    const needle = q().toLowerCase().trim()
    if (!needle) return props.commands
    return props.commands.filter((c) =>
      c.label.toLowerCase().includes(needle) || (c.keywords ?? []).some((k) => k.includes(needle)),
    )
  }

  return (
    <KDialog open={open()} onOpenChange={setOpen}>
      <KDialog.Portal>
        <KDialog.Overlay class="fixed inset-0 bg-fg/40 backdrop-blur-sm z-40" />
        <KDialog.Content class="fixed left-1/2 top-24 -translate-x-1/2 bg-surface rounded-xl shadow-lg w-[95vw] max-w-xl z-50 overflow-hidden">
          <div class="flex items-center gap-2 border-b border-border px-4 py-3">
            <Search size={18} class="text-muted" />
            <input
              autofocus
              placeholder="Cerca..."
              class="flex-1 bg-transparent outline-none text-base"
              value={q()}
              onInput={(e) => setQ(e.currentTarget.value)}
              onKeyDown={(e) => { if (e.key === 'Escape') setOpen(false) }}
            />
            <kbd class="text-xs text-muted">ESC</kbd>
          </div>
          <ul class="max-h-80 overflow-y-auto py-1">
            <For each={filtered()}>
              {(c) => (
                <li>
                  <button
                    class="w-full text-left px-4 py-2 text-sm hover:bg-accent-soft flex justify-between items-center"
                    onClick={() => { c.action(); setOpen(false) }}
                  >
                    <span>{c.label}</span>
                    {c.hint && <span class="text-xs text-muted">{c.hint}</span>}
                  </button>
                </li>
              )}
            </For>
          </ul>
        </KDialog.Content>
      </KDialog.Portal>
    </KDialog>
  )
}
